import { useLocation } from "react-router-dom";
import { useLoadingState } from "@/hooks/useLoadingState";
import { LoadingIndicator } from "@/components/ui/loading-screen";
import { usesSidebarShell } from "@/utils/sidebarShellRoutes";

export function LoadingFallback() {
  useLoadingState({ isLoading: true });
  const location = useLocation();

  // On the redesigned sidebar-shell pages, Layout renders the rail nav
  // outside this Suspense boundary so it stays mounted and static across
  // route transitions. Keep this fallback scoped to the center content
  // column instead of covering the whole viewport, so the sidebar never
  // flashes away while a page's code chunk loads.
  if (usesSidebarShell(location.pathname)) {
    return (
      <div className="flex min-h-[70vh] w-full items-center justify-center bg-white">
        <LoadingIndicator />
      </div>
    );
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center min-h-screen bg-white">
      <LoadingIndicator />
    </div>
  );
}
